import { useLanguageMessages } from "~/composables/useLanguageMessage"

type LanguageMessagesResult = {
  language: string
  item: {
    key: string
    value: string
  }[]
}

type i18nMessages = Record<string, string>

type LanguageRow = {
  key: string
  value: string
}

// export default defineI18nLocale(async (locale) => {
//   try {
//     const { data } = await useSanityQuery<LanguageMessagesResult[]>(getLanguage, {
//       key: 'en',
//       language: locale,
//       cacheKey: `english-i18n-${locale}`,
//     })
//     console.log(`english-i18n-${locale}`)
//     if (!data.value?.length) return {}

//     const { item } = data.value.find(
//       (result) => result.language === locale,
//     ) as LanguageMessagesResult

//     let messages: i18nMessages = {}

//     item.forEach((row: LanguageRow) => {
//       if (!row.key) return

//       messages[row.key] = row.value
//     })

//     return messages
//   } catch (error) {
//     console.error(error)
//     return {}
//   }
// })
// da.ts or en.ts
export default defineI18nLocale(async (locale) => {
  return await useLanguageMessages(locale)
})
